import styled from 'styled-components';

export const WarrantiesCardWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgb(24 53 88 / 10%);
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
`;
export const WarrrantiesChevronIconWrapper = styled.span`
  display: flex;
  flex-direction: row;
  padding-top: 6px;
`;
export const WarrantiesCardHeaderContainer = styled.div`
  padding: 20px 24px;
  display: flex;
  align-items: center;
`;
export const WarrantiesHeader = styled.div`
  font-family: Brandon Text;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: var(--cvna-color-blue-6);
`;
export const WarrantiesCardContentContainer = styled.div`
  font-family: Brandon Text;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #757989;
  padding: 0 24px;
`;
export const HeaderButton = styled.button<any>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: none;
  outline: none;
  border-color: none;
  background: #ffffff;
  margin-left: 0;
  padding: 0;
  width: 100%;
  cursor: pointer;

  &:focus {
    outline: none;
    outline: 0px auto -webkit-focus-ring-color;
  }

  &:hover {
    border: none;
    outline: none;
    border-color: none;
    background: #ffffff;
    box-shadow: 0 0 0 0px white, 0 0 0 0px #ffffff;
  }
`;

export const HeaderIcon = styled.div`
  margin-right: 16px;
  height: 32px;
`;

export const HR = styled.hr`
  border: 1px solid #d9dde9;
  border-bottom-color: transparent;
  margin: 24px 0;
`;
